import React from 'react';
import {MESSAGE_PERMISSION_OPTIONS, PROFILE_VISIBILITY_OPTIONS} from '../constants';
import styles from '../Settings.module.css';

const privacyHeaderIconStyle = {
  '--settings-privacy-icon-url': `url("${process.env.PUBLIC_URL}/icons/lock-outline.svg")`,
} as React.CSSProperties;

const SettingsPrivacySection: React.FC = () => (
  <section className={`${styles.settingsCard} ${styles.compactSettingsCard} ${styles.privacyCard}`}>
    <div className={styles.sectionHeadingRow}>
      <span className={styles.sectionIcon}>
        <span className={styles.privacyHeaderIconAsset} style={privacyHeaderIconStyle} aria-hidden="true" />
      </span>
      <div>
        <h3 className={styles.settingsCardTitle}>Privacy</h3>
        <p className={styles.settingsCardSubtitle}>Control who can see your content and interact with you.</p>
      </div>
    </div>

    <div className={styles.compactSettingRow}>
      <div><strong>Profile Visibility</strong><span>Choose who can see your profile.</span></div>
      <select className={styles.settingsSelect} aria-label="Profile visibility">
        {PROFILE_VISIBILITY_OPTIONS.map((option) => <option key={option}>{option}</option>)}
      </select>
    </div>
    <div className={styles.compactSettingRow}>
      <div><strong>Show Activity Status</strong><span>Allow others to see when you're active.</span></div>
      <label className={styles.switchLabel} aria-label="Show activity status">
        <input type="checkbox" className={styles.switchInput} defaultChecked />
        <span className={styles.switchTrack} />
      </label>
    </div>
    <div className={styles.compactSettingRow}>
      <div><strong>Allow Messages From</strong><span>Choose who can send you messages.</span></div>
      <select className={styles.settingsSelect} aria-label="Allow messages from">
        {MESSAGE_PERMISSION_OPTIONS.map((option) => <option key={option}>{option}</option>)}
      </select>
    </div>
  </section>
);

export default React.memo(SettingsPrivacySection);
